import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnChanges,
	OnInit,
	Optional,
	Output,
	SimpleChanges,
} from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { FromFieldControl } from "@dodo/material-forms/form-field-control";

@Component({
    selector: "measurement-input",
    templateUrl: "./measurement-input.component.html",
    styleUrls: ["./measurement-input.component.scss"],
    standalone: false
})
export class MeasurementInputComponent
	extends FromFieldControl
	implements OnInit, OnChanges {
	// Public Variables
	public errorMessage: string;
	public hasError: boolean;
	public inputIsWrong: boolean;
	public showMeasurement: boolean;
	public touched: boolean;
	public isValid: boolean;
	public showValidTick: boolean;
	public inputValue = "";
	// Input Variables
	@Input() required: boolean;
	@Input() measurement: string;
	@Input() placeholder: string;
	@Input() validImage: string;
	@Input() invalidImage: string;
	@Input() defaultValue: string;
	@Input() margin: boolean;
	@Input() touchRemoved: boolean;
	// Output Variables
	@Output() userInput: EventEmitter<any> = new EventEmitter();
	@Output() inputError: EventEmitter<boolean> = new EventEmitter();

	// Constructor
	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		__formGroupDirective: FormGroupDirective
	) {
		super(__formGroupDirective);
	}

	// OnInit
	ngOnInit() {
		this.hasError = false;
		this.touched = false;
		this.isValid = true;
		this.showValidTick = false;

		if (this.defaultValue && this.defaultValue?.length > 0) {
			this.inputValue = this.defaultValue;
			this.showCustomMeasurement();
			this.checkInputText(this.inputValue);
		}
	}

	// OnChanges
	ngOnChanges(changes: any) {
		if (changes["required"]) {
			if (this.required && this.inputValue.length > 0) {
				this.checkInputText(this.inputValue);
			} else {
				this.hasError = false;
			}
		}
		if (changes["touchRemoved"]) {
			if (this.inputValue.length == 0 && this.touchRemoved) {
				this.touched = false;
			}
		}
		if (changes["defaultValue"]) {
			if (this.defaultValue && this.defaultValue?.length > 0) {
				this.inputValue = this.defaultValue;
				this.showCustomMeasurement();
				this.checkInputText(this.inputValue);
			}
		}
	}

	/**
	 * Input Interaction Methods
	 */

	// Check the values in the input
	public checkInputText(event) {
		if (event?.target) {
			// Get the value from the text-field
			this.inputValue = event.target.value;
		} else {
			this.inputValue = event;
		}

		// Check to make sure the input is numbers only
		const regEx = /^\d+$/;
		this.isValid = regEx.test(this.inputValue);
		// If the input is valid, emit its value
		if (this.isValid) {
			this.userInput.emit(this.inputValue);
			this.showValidTick = true;
		} else {
			this.userInput.emit(this.inputValue);
			this.showValidTick = false;
		}

		this.errorCheck();
	}

	// Show the custom measurement writing
	public showCustomMeasurement() {
		// Check to make sure the element is touched
		if (!this.touched) {
			this.touched = true;
		}

		this.showMeasurement = true;
	}

	// Hide the custom measurement writing
	public hideCustomMeasurement() {
		if (this.inputValue.length == 0) {
			this.showMeasurement = false;
		}
	}

	/**
	 * ERROR CHECKING
	 */

	// Check required error
	public errorCheck() {
		if (this.inputValue?.length > 0 && !this.isValid) {
			this.hasError = true;
			this.errorMessage = "please enter a valid input";
			this.inputError.emit(true);
			return;
		}
		if (this.inputValue?.length == 0 && this.touched && this.required) {
			this.hasError = true;
			this.errorMessage = this.placeholder + " is required";
			this.inputError.emit(true);
			return;
		}
		// Default error state of false
		this.hasError = false;
		this.inputError.emit(false);
	}
}
